export const rendererSettingsChangedState = {
    true: '1',
    false: '0',
};
export const MULTILINE_TAGS = {
    renderMultiline: '.mm.cellRenderer.renderMultiline',
    monomersPerLine: '.mm.cellRenderer.monomersPerLine',
    maxVisibleLines: '.mm.cellRenderer.maxVisibleLines'
};
//# sourceMappingURL=cell-renderer-consts.js.map